import type { ListBuilderList } from '../../../types';
import {
	accountColumn,
	actionColumn,
	fileVsRegulatorColumn,
	licenseColumn,
	salesColumn,
	whyHereColumn,
} from '../columns';
import { hideOtherCardFilters } from '../filter-rules';

/**
 * Expiring Soon — active buyers' VERIFIED licenses whose regulator (else file)
 * expiration falls within 30 days: the dashboard card's own predicate
 * (licenseVerifiedExpiringSoonSql), so the card and the list agree.
 */
export const expiringSoonComplianceList: ListBuilderList = {
	id: 'compliance-expiring-soon',
	cacheTTL: 300000,
	// Tab label, deliberately short (Chris, 2026-09-20) so more tabs show in
	// the Needs Attention strip; the rest sit under More, which is accepted
	// (Chris, 2026-09-27). The full name is above and on the dashboard card.
	name: 'Expiring',
	type: 'default',
	active: true,
	sortOrder: 8,
	filterRules: {
		...hideOtherCardFilters(['licenseVerifiedExpiringSoon']),
		licenseActiveBuyer: {
			defaultValue: [{ id: 'yes', label: 'Buying (sale in 90 days)' }],
			locked: true,
		},
		licenseVerifiedExpiringSoon: {
			defaultValue: [
				{ id: 'yes', label: 'Verified license expiring within 30 days' },
			],
			// Unlocked: the dashboard's 31 – 60 and 61 – 90 day tiles open this
			// list with the later window preselected.
		},
	},
	columns: [
		accountColumn,
		salesColumn,
		licenseColumn,
		fileVsRegulatorColumn,
		whyHereColumn,
		actionColumn,
	],
	defaultSortId: 'sales-90-desc',
};
